import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

/** ScreenModule IR authority — Component is the shared product route adapter. */

export const resource_detailScreenModule = defineScreen({
  app: "coaching",
  screen_id: "resource-detail",
  path: "/resources/:resource_id",
  params: ["resource_id"],
  heading: { text: "Resource detail", level: 1 },
  roles: {
    "super_admin": "allow",
    "admin": "allow",
    "coach": "allow",
    "company_admin": "allow",
    "participant": "deny",
    "cohort_lead": "allow"
  },
  states: ["ready"],
  actions: [
    { id: "load", kind: "secondary", driver: "detail.load" }
  ],
  recipe: "Detail-1",
  data: { seedNeeds: ["readonly-walk-session", "populated-list-min1"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/resource-detail.tsx" },
  Component: ProductRouteScreenAdapter,
});

export default resource_detailScreenModule;
